import React from "react";
import EmployeeDetails from "../../components/EmployeeDetails";
import InterviewSchedule from "../../components/InterviewSchedule";
import EmployeeProfileForm from "../../components/EmployeeProfileForm";

export default function EmployeePage() {
  return (
    <div className="bg-light p-2">

      <EmployeeDetails />

      <div className="mt-3">
        <EmployeeProfileForm />
      </div>

      <div className="mt-3">
        <InterviewSchedule />
      </div>

    </div>
  );
}

